import { Modal } from '../uiLib'
const AppWrapper = props => (
  <div>
    {!props.hasRemoteSessions && props.children}
    <Modal
      isShown={props.showDuplicateLoginModal}
      title={props.t('duplicate_login_modal-title')}
      bodyContent={props.t('duplicate_login_modal-body', { user: props.user.username })}
      onCancelClick={props.terminateCurrentSession}
      cancelBtnText={props.t('cancel')}
      onConfirmClick={props.terminateOtherSessions}
      confirmBtnText={props.t('OK')}
    />
  </div>
)

export default AppWrapper



// WEBPACK FOOTER //
// ./components/AppWrapper/AppWrapper.js